import React from 'react';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import Module from '../../components/Module';
import ModuleHeader from '../../components/ModuleHeader/ModuleHeader';
import ModuleContent from '../../components/ModuleContent';
import SubModule from '../../components/SubModule';
import SubModuleHeader from '../../components/SubModuleHeader';
import SubModuleContent from '../../components/SubModuleContent';
import styles from './FAQ.style';
import ContactModule from '../../components/ContactModule';

const FAQ = () => (
  <>
    <PageTitle>Support</PageTitle>

    <Main className={styles.root}>
      <ModuleHeader>Frequently Asked Questions</ModuleHeader>
      <Module>
        <ModuleContent>
          <SubModule closed>
            <SubModuleHeader id="faqheading1">What is new in Royalties Portal?</SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Royalties Operations Team is deploying a fully redesigned royalties solution using
                the transformative blockchain technology and an integrated web-based access to
                deliver:
                <ol className={styles.listBullet}>
                  <li>
                    Access to near real time current period transactions along with royalties
                    computation as opposed to 45 days after period end
                  </li>
                  <li>
                    Full visibility into contractual and product setup thereby reducing
                    after-the-fact reconciliation and downstream errors
                  </li>
                  <li>
                    Single point access for your current period transactions and prior period
                    statements through a redesigned partner portal
                  </li>
                </ol>
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading2">
              When will I receive my monthly royalties statements?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Statements will now be available sooner than the current timeline of 45 days after
                the month end. Our goal is to deliver the finalized statements within 7 days after
                month end. Transactions summary and royalties earned amount will be visible in real
                time on the Royalties Portal. For the initial few months after launch, in most cases
                statements will be available within 15 days after the month end and in a few cases
                it might take up to 30 days after the month end.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading3">How will I receive my statements?</SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Statements can be accessed through this application once they are finalized and
                published. You will get a notification as soon as the statements are ready.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading4">Will I be paid sooner?</SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Payment terms will remain unchanged and we will continue to pay on the net 45 day
                payment term as agreed upon in the Title Licensing Agreement.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading5">
              Who should I contact if I face any issues while logging in?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                You can contact Roycare (roycare@microsoft.com) if you have login or other
                questions. No change in the help and support we are providing our partners. We will
                be adding more resources for you to the get the support you need.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading6">
              Will I be able to access my past statements?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Past statements are available on the Royalty Application statements page starting
                from the July 2018 statement period. If you would like to view a statement from
                before July 2018, please reach out to Roycare (roycare@microsoft.com).
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading7">
              How can I provide feedback on this new tool?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Our main goal is to provide our partners a world class experience and we truly
                believe that this redesigned portal with enhanced functionality and insights is a
                step in that direction. We are constantly looking to improve and thus highly value
                your feedback. You can provide feedback directly from the application through the
                <FontIcon iconName="QandA" className={styles.support} title="Support" />
                button found at the top right corner of the application next to the user avatar. You
                can also reach out to Roycare (roycare@microsoft.com) for any feedback that you may
                have.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading8">
              What should I do if I see something I believe is incorrect?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Please reach out to Roycare (roycare@microsoft.com) for any questions about the data
                and information you see on the portal. We will respond to you within 24 hours of
                receiving your query with a resolution.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading9">
              How can I request access for additional users?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                Please reach out to Roycare (roycare@microsoft.com) to request access for any
                additional users.
              </Text>
            </SubModuleContent>
          </SubModule>

          <SubModule closed>
            <SubModuleHeader id="faqheading10">
              Does this change our contract with Microsoft?
            </SubModuleHeader>

            <SubModuleContent>
              <Text as="p" variant="medium" block className={styles.bodyText}>
                This platform does not impact any agreed upon terms and conditions as per the Title
                Licensing Agreement that you have with Microsoft.
              </Text>
            </SubModuleContent>
          </SubModule>
        </ModuleContent>
      </Module>

      <ModuleHeader>Contact Us</ModuleHeader>
      <ContactModule
        body="Contact Royalty and Content Operations via email for any questions regarding your contracts, statements, or use of this portal."
        mail="roycare@microsoft.com"
      />
    </Main>
  </>
);

export default FAQ;
